
// SVG Icon: eye
export default { id: "terriajs-eye" };
export const id = "terriajs-eye";
export const name = "eye";
